import React from 'react';
import { SlidePage } from '../index';
import { BodyContainer, ProgressBox, ProgressStat } from '../styles';
import { polarColors } from '../constants';

const getColor = value => {
  if (value < 25) {
    return polarColors[4];
  }
  if (value < 50) {
    return polarColors[3];
  }
  if (value < 75) {
    return polarColors[1];
  }
  return polarColors[0];
};

const VocationalMaturitySecondPage = ({ user, background, number }) => {
  // const infoSobreSiMismo = parseFloat(user['Información sobre el Self']);
  // const infoSobreProceso = parseFloat(user['Información sobre el proceso']);
  const confictosExternos = parseFloat(user['Conflictos externos']);
  const confictosInternos = parseFloat(user['Conflictos internos']);

  return (
    <SlidePage number={number} background={background}>
      <BodyContainer>
        <div className='content'>
          <h3 style={{ marginBottom: '0.5rem' }}>Conflictos externos. </h3>
          <p className='justified'>
            Los conflictos externos suelen surgir cuando existe una{' '}
            <strong>
              discrepancia entre tus propios intereses y lo que crees que los
              demás esperan de ti
            </strong>
            . Este tipo de conflicto puede presentarse si tus aspiraciones
            vocacionales no se alinean con las expectativas que otros tienen
            para tu futuro. Por ejemplo, puedes tener una pasión por el arte y
            desear estudiar bellas artes, pero sientes que tu familia espera que
            sigas una carrera en el derecho porque es una tradición familiar.
            Este tipo de discrepancia puede generar una considerable tensión y
            confusión, dificultando el proceso de toma de decisiones.
          </p>
          <div className='paragraph'>¿Cómo afrontar esta situación?</div>
          <ul className='text-list'>
            <li>
              - Comunicación abierta (Habla con las personas cuyas expectativas
              te preocupan. Expresa tus sentimientos y aspiraciones, y trata de
              entender su perspectiva. En algunos casos, podrías descubrir que
              tus percepciones sobre sus expectativas no son completamente
              precisas).
            </li>
            <li>
              - Establece tus propios criterios de elección basadas en
              información objetiva.
            </li>
            <li>- Autoafirmación (conoce tus habilidades, gustos, etc).</li>
          </ul>
          <br />
          <div className='progress-info-group'>
            <div className='progress-info'>
              <div className='progress-details-single'>
                {/* <div className='progress-name'>Conflictos externos</div> */}
                <ProgressBox
                  progress={confictosExternos}
                  backColor={() => getColor(confictosExternos)}
                >
                  <div className='progress'></div>
                </ProgressBox>
                <ProgressStat>{confictosExternos}</ProgressStat>
              </div>
            </div>
          </div>

          <br />

          <h3 style={{ marginBottom: '0.5rem' }}>Conflictos internos. </h3>
          <p className='justified'>
            Surgen de la discordancia o{' '}
            <strong>
              discrepancia que puedes sentir entre tus aspiraciones personales y
              tus propias capacidades (auto-percibidas)
            </strong>
            . Estas tensiones también pueden manifestarse cuando te encuentras
            atraído por una carrera, pero hay aspectos de la carrera que te
            pueden parecer difíciles o menos atractivos y por consecuencia, te
            generan incertidumbre o dudas en tu elección.
          </p>
          {/* <p className='justified'>
            Por ejemplo, puedes tener una pasión por la música y soñar con
            dedicarte profesionalmente, pero sientes que no tienes la habilidad
            técnica requerida. O tal vez tienes interés en estudiar medicina,
            pero la idea de realizar procedimientos quirúrgicos o trabajar en un
            entorno hospitalario no te resulta atractivo, o derechamente sientes
            que tus habilidades en ciencias no son las mejores, lo que te
            desanima.
          </p> */}
          <div className='paragraph'>¿Cómo afrontar esta situación?</div>
          <ul className='text-list'>
            <li>- Evalúa y entrena tus habilidades.</li>
            <li>
              - Capacitación, aprendizaje y entrenamiento (las habilidades
              pueden practicarse).
            </li>
            <li>
              - Investigación profunda (investiga a fondo las carreras de tu
              interés para enfrentar los prejuicios o ideas erróneas que puedas
              tener acerca de la carrera y tus habilidades actuales).
            </li>
          </ul>
          <br />
          <div className='progress-info-group'>
            <div className='progress-info'>
              <div className='progress-details-single'>
                {/* <div className='progress-name'>Conflictos internos</div> */}
                <ProgressBox
                  progress={confictosInternos}
                  backColor={() => getColor(confictosInternos)}
                >
                  <div className='progress'></div>
                </ProgressBox>
                <ProgressStat>{confictosInternos}</ProgressStat>
              </div>
            </div>
          </div>
          <br />
        </div>
      </BodyContainer>
    </SlidePage>
  );
};

export default VocationalMaturitySecondPage;
